import React from "react";
import Info from "../../components/InfoCard/Info";
import style from "./Count.module.scss";
import { useNavigate } from "react-router-dom";
import { BiListUl, BiListCheck } from "react-icons/bi";
import { MdTimerOff, MdOutlineCancelPresentation } from "react-icons/md";
import { BsFillImageFill } from "react-icons/bs";
import { VscDebugStepOver } from "react-icons/vsc";

const Counts = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <div className={style.container}>
        <Info
          bgColor={"#F0FDE0"}
          color={"#78A55A"}
          icon={<BiListUl size={30} />}
          value={props.ongoing}
          cardText={"Ongoing Orders"}
          onClick={() => navigate("/ongoing")}
        />
        <Info
          bgColor={"#FFEFE8"}
          color={"#FBA243"}
          icon={<BiListCheck size={30} />}
          value={props.completed}
          cardText={"Completed Orders"}
          onClick={() => navigate("/completed")}
        />
        <Info
          bgColor={"#FFEFE8"}
          color={"#FBA243"}
          icon={<MdTimerOff size={30} />}
          value={props.overdue}
          cardText={"Overdue Orders"}
          onClick={() => navigate("/overdue")}
        />
        <Info
          bgColor={"#FDE0E0"}
          color={"#B70303"}
          icon={<MdOutlineCancelPresentation size={30} />}
          value={props.cancelled}
          cardText={"Cancelled Orders"}
          onClick={() => navigate("/cancelled")}
        />

        <Info
          bgColor={"#FDE0E0"}
          color={"#A23456"}
          icon={<VscDebugStepOver size={30} />}
          value={props.override}
          cardText={"Override Orders"}
          onClick={() => navigate("/override")}
        />
      </div>
    </>
  );
};

export default Counts;
